import React from "react";
import Dialog from "commons/muiCustomComponents/Dailog";
import Grid from "commons/muiCustomComponents/Grid";
import Box from "commons/muiCustomComponents/Box";
import Button from "commons/muiCustomComponents/Button";
import { makeStyles } from '@material-ui/core/styles';
import MobileProvider from "commons/context/MobileProvider";
import Header from "./components/Header";
import { LinearLoader } from "commons/commonWrapper/Loaders";
import Footer from "./components/Footer";
import ArrowForward from "@material-ui/icons/ArrowForward";
import Edit from "@material-ui/icons/Edit";
import ProgressDialouge from "./components/progressDialouge";
import CloseIcon from '@material-ui/icons/Close';
import VideoPlayer from 'react-video-js-player';


const useStyles = makeStyles(theme => ({
  stepSection : {
    display:'flex',
    justifyContent:'flex-end',
  },
  mobileTitle:{
    justifyContent:'center',
    display:'flex',
  },
  nextButton: {
    paddingTop:theme.spacing(4),
    paddingBottom:theme.spacing(4),
    width:theme.spacing(50),
    borderRadius:theme.spacing(8),
    margin:theme.spacing(2),
  },
  footerButtonMobile: {
    paddingTop:theme.spacing(2),
    paddingBottom:theme.spacing(2),
    borderRadius:theme.spacing(1),
  },
  mobileFooterContainer: {
    padding:theme.spacing(4),
  },
  mobileFooterItem: {
    paddingLeft:theme.spacing(2),
    paddingRight:theme.spacing(2),
  },
  snapImage: {
    width:'100%',
    height:'100%',
    objectFit:'cover',
  },
  snapImageBox: {
    marginTop:theme.spacing(1),
    width:'100%',
    height:theme.isMobile ? theme.spacing(50): theme.spacing(50),
  },
  selectImage: {
    paddingTop:theme.spacing(2),
    // height:'100%',
  },
  titleArea: {
    background: theme.palette.pubPaleGrey,
    color: theme.palette.primary.main,
    fontSize:theme.spacing(6),
    paddingTop:theme.spacing(4),
    paddingBottom:theme.spacing(4),
  },
  descriptionArea: {
    // marginTop:theme.spacing(3),
  },
  contentContainer: {
    width:'100%',
    margin:theme.spacing(2),
  },
  preText: {
    whiteSpace:'pre-wrap',
  },
  backgroundFullScreen:{
    backgroundColor:theme.palette.pubBackground,
  },
}));

function ArticlePreview(props) {
  
  const classes = useStyles();
  const isMobile = React.useContext(MobileProvider);
  const { showProgress, savingArticle } = props;
  return (
    <>
    {<ProgressDialouge open={showProgress} savingarticle={savingArticle} />}
      <Dialog fullWidth maxWidth="md" open={props.open} onClose={props.closeDialog} classes={{paper:classes.backgroundFullScreen}}>
        <Grid container>
          {/**----------------------------Header Section---------------------------- */}
            <Header>
            <Grid container justify="center">
              <Grid item xs={12} md={12}>
                    <Box display="flex" alignItems="center" justifyContent="space-between" ml={isMobile ?4:25} mr={isMobile ?4:25} >
                      <Box display="flex" alignItems="center" height="100%">
                          <CloseIcon style={{color:'white'}} onClick={props.closePreview}/>
                      </Box>
                      <Box component="p" display="flex" justifyContent="center">Post preview</Box>
                      <Box  component="p" ></Box>
                      </Box>
                  </Grid>
            </Grid>
            </Header>
            {props.savingMeta  && <LinearLoader/>}
          {/**----------------------------End Header Section---------------------------- */}



          {/**---------------------------Main Container Section--------------------------*/}
          <Grid container justify="center">
            <Grid container>
              <Grid item xs={12} md={12}>
              {props.savingMeta  && <LinearLoader/>}
              </Grid>
            </Grid>
            
            {<Grid container justify="center" className={classes.titleArea}>
              <Grid item xs={12} md={8}>
                <span>{props.title}</span>
              </Grid>
            </Grid>}
            <span className={classes.contentContainer}>
            <Grid container justify="center" className={classes.selectImage}>
              <Grid item xs={12} md={4} >
                <Box className={classes.snapImageBox}>
                  {props.metadata && props.metadata.hlsUrl 
                  && <VideoPlayer src={props.metadata.hlsUrl} width="279" height="152" controls/>}
                </Box>
              </Grid>
            </Grid>
            <Grid container justify="center" className={classes.descriptionArea}>
              <Grid item xs={12} md={8}>
              <p className={classes.preText}>
                   {props.metadata && props.metadata.richDescription && <Box  dangerouslySetInnerHTML={{__html:props.metadata.richDescription.html}}></Box>}
                </p>
              </Grid>
            </Grid>
            </span>
          </Grid>
          {/**---------------------------End Main Container Section--------------------------*/}


          {/**----------------------------Footer Section-------------------------------------*/}
          <Grid item xs={12} md={12}>
            
          </Grid>
          {/**----------------------------End Footer Section-------------------------------------*/}
        </Grid>
      </Dialog>
    </>
  )
}

export default ArticlePreview;